import React from 'react'
import { IoConstructOutline, IoNavigateOutline, IoReceiptOutline } from 'react-icons/io5'
import { GiGasPump, GiCarWheel } from 'react-icons/gi'
import { MdToll } from 'react-icons/md'

export const EVALUATION_TYPES = [
    { key: 'Entretien', label: 'Entretien et réparations', icon: <IoConstructOutline /> },
    { key: 'Carburant', label: 'Carburant', icon: <GiGasPump /> },
    { key: 'Pneumatiques', label: 'Pneumatiques', icon: <GiCarWheel /> },
    { key: 'Peages', label: 'Péages', icon: <MdToll /> },
    { key: 'Deplacement', label: 'Indemnités de déplacement', icon: <IoNavigateOutline /> },
    { key: 'AutreCout', label: 'Autres coûts', icon: <IoReceiptOutline /> },
]

export const EVALUATION_YEARS = [2026, 2025, 2024]

const MONTH_LABELS = ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc']

// Base annual budget and typical monthly spend per category (MAD) — Carburant is
// deliberately tuned to run over budget, matching a real fleet office's usual pain point.
const BASE_PARAMS = {
    Entretien: { annualBudget: 180000, monthlyAverage: 11500 },
    Carburant: { annualBudget: 420000, monthlyAverage: 38500 },
    Pneumatiques: { annualBudget: 60000, monthlyAverage: 4200 },
    Peages: { annualBudget: 24000, monthlyAverage: 1850 },
    Deplacement: { annualBudget: 96000, monthlyAverage: 7600 },
    AutreCout: { annualBudget: 40000, monthlyAverage: 3100 },
}

function seededRandom(seed) {
    let value = seed % 2147483647
    if (value <= 0) value += 2147483646
    return () => {
        value = (value * 16807) % 2147483647
        return (value - 1) / 2147483646
    }
}

function hashString(str) {
    let hash = 0
    for (let i = 0; i < str.length; i++) {
        hash = (hash * 31 + str.charCodeAt(i)) % 2147483647
    }
    return hash || 1
}

export function getMockEvaluationData(typeKey, year) {
    const params = BASE_PARAMS[typeKey]
    if (!params) return null

    const yearFactor = 1 + (year - 2024) * 0.06
    const allowedBudget = Math.round(params.annualBudget * yearFactor)

    const rand = seededRandom(hashString(`${typeKey}-${year}`))
    const monthlyValues = MONTH_LABELS.map(() => {
        const variance = 1 + (rand() - 0.5) * 0.5
        return Math.max(0, Math.round(params.monthlyAverage * yearFactor * variance))
    })

    const consomedBudget = monthlyValues.reduce((sum, v) => sum + v, 0)
    const restBudget = allowedBudget - consomedBudget

    return {
        allowedBudget,
        consomedBudget,
        restBudget,
        averageAllowedBudgetByMonth: Math.round(allowedBudget / 12),
        averageConsomedBudgetByMonth: Math.round(consomedBudget / 12),
        dataByMonth: MONTH_LABELS.map((month, i) => ({ month, value: monthlyValues[i] })),
    }
}
